// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"review-moderation_wrapper__OfDEU","step":"review-moderation_step___e2mV","buttons":"review-moderation_buttons__bxz0m","button":"review-moderation_button__xTrQL"};